import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useGetKeywordQuestionCardCursorPageQuery } from '@/hooks/qna/mobile/qna.gql.impl';
import * as Types from '@/types/bff/gql-schema';

const useGetKeywordQuestionCardInfiniteQuery = <T>(
  variables: Types.GetKeywordQuestionCardCursorPageQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<Types.GetKeywordQuestionCardCursorPageQuery, AxiosError, T>
) => {
  return useInfiniteQuery<Types.GetKeywordQuestionCardCursorPageQuery, AxiosError, T>(
    ['getKeywordQuestionCardCursorPage', variables],
    ({ pageParam }) => {
      return useGetKeywordQuestionCardCursorPageQuery.fetcher({
        request: {
          ...variables.request,
          pivot: pageParam,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage: Types.GetKeywordQuestionCardCursorPageQuery) => {
        const size = variables.request.size as number;
        if (lastPage.keywordSearchQuestionCardCursorPage.elements.length < size) {
          return undefined;
        }

        return lastPage.keywordSearchQuestionCardCursorPage.pivot;
      },
    }
  );
};
export default useGetKeywordQuestionCardInfiniteQuery;
